module.exports = __webpack_public_path__ + "img/screen.84591e45.svg";